import React, { useState } from "react";
import { jobCoverSrc, categoryCover } from "../lib/covers";

/**
 * Imagem da vaga com fallback automático: se a capa da empresa não existir (404),
 * cai na foto do setor sem deixar espaço vazio.
 */
export const JobCoverImage = ({ job, className = "", alt }) => {
  const [src, setSrc] = useState(() => jobCoverSrc(job));
  const fallback = categoryCover(job?.category);

  return (
    <img
      src={src}
      alt={alt || `Imagem da vaga ${job?.title || ""}`.trim()}
      loading="lazy"
      data-testid={`job-cover-${job?.slug || job?.id || "x"}`}
      onError={() => {
        if (src !== fallback) setSrc(fallback);
      }}
      className={className}
    />
  );
};

export default JobCoverImage;
